<div class="title p-2">
    <div class="row">
        <div class="col d-flex justify-content-start">
            <h1 class="mx-1"><i class="fa-solid fa-paperclip me-2"></i>Anexe Document</h1>
        </div>
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="container p-3">
    <!-- Upload Section -->
    <div class="row">
        <div class="col">
            <div class="solicitare-card__upload">
                <div class="solicitare-card__upload-header">
                    <p class="upload-text">
                        <i class="fa-solid fa-file me-2"></i>
                        Selectează fișierele (PDF, DOC, XLS, PNG, JPG - max 10MB)
                    </p>
                    <button class="upload-btn" (click)="fileInput.click()" type="button" [disabled]="uploading">
                        <mat-icon class="upload-icon">cloud_upload</mat-icon>
                        ÎNCARCĂ
                    </button>
                </div>

                <!-- Lista fișiere încărcate (pending) -->
                <div class="solicitare-card__upload-files" *ngIf="uploadedFiles.length > 0">
                    <div class="solicitare-card__upload-file" *ngFor="let file of uploadedFiles; let i = index">
                        <span class="solicitare-card__upload-file-name">
                            {{ (file.original_name.length > 40) ?
                                (file.original_name | slice:0:40) + '...' :
                                file.original_name }}
                        </span>
                        <div class="d-flex gap-4 align-items-center">
                            <button class="solicitare-card__upload-file-view" type="button"
                                matTooltip="Vizualizează fișierul" (click)="viewUploadedFile(file)">
                                <mat-icon class="btn-icon">visibility</mat-icon>
                                <span class="btn-text">Vizualizează</span>
                            </button>
                            <button class="solicitare-card__upload-file-delete" type="button"
                                matTooltip="Șterge fișierul" (click)="removeFile(i)">
                                <img class="btn-img" src="assets/icons/delete.svg" alt="Șterge" />
                            </button>
                        </div>
                    </div>
                </div>

                <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                    *ngIf="uploading"></mat-spinner>

                <input type="file" #fileInput multiple [accept]="allowedExtensions"
                    (change)="addFile($event)" style="display: none">
            </div>
        </div>
    </div>

    <!-- Anexe existente -->
    <div class="row mt-4" *ngIf="data.existingAnexe && data.existingAnexe.length > 0">
        <div class="col">
            <h6 class="mb-3"><i class="fa-solid fa-list me-2"></i>Anexe existente</h6>
            <div class="existing-anexe-list">
                <div class="anexa-item d-flex align-items-center justify-content-between mb-2 p-2"
                    *ngFor="let anexa of data.existingAnexe">
                    <span class="anexa-name">
                        <i class="fa-solid fa-file-alt me-2"></i>
                        {{ anexa.old_name }}
                    </span>
                    <div class="d-flex gap-2 align-items-center">
                        <button class="btn btn-sm btn-outline-primary"
                            (click)="viewExistingAnexa(anexa)"
                            title="Vizualizează anexa">
                            <i class="fa-solid fa-eye"></i>
                            Vizualizează
                        </button>
                        <button class="btn btn-sm btn-outline-danger"
                            *ngIf="data.canDelete"
                            (click)="deleteExistingAnexa(anexa)"
                            title="Șterge anexa">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                        <span class="text-muted small" *ngIf="!data.canDelete">
                            <i class="fa-solid fa-lock me-1"></i>
                            Blocat
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Mesaj informativ dacă nu se poate șterge -->
    <div class="row mt-2" *ngIf="data.existingAnexe && data.existingAnexe.length > 0 && !data.canDelete">
        <div class="col">
            <div class="alert alert-info mb-0 py-2">
                <i class="fa-solid fa-info-circle me-2"></i>
                Anexele nu pot fi șterse deoarece notificarea a fost deja trimisă.
            </div>
        </div>
    </div>

    <!-- Butoane acțiune -->
    <div class="row mt-4">
        <div class="col">
            <div class="d-flex justify-content-end">
                <button type="button" class="buttons me-2" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="button"
                    [disabled]="uploadedFiles.length === 0 || isLoading"
                    (click)="submitAnexe()">
                    <mat-spinner diameter="18" *ngIf="isLoading" class="me-2"
                        style="display: inline-block;"></mat-spinner>
                    <i class="fa-solid fa-save me-1" *ngIf="!isLoading"></i>
                    Salvează Anexele
                </button>
            </div>
        </div>
    </div>
</div>

<div class="section-spinner position-absolute" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>
